import {
  RuleBusinessType as ApiRuleBusinessType,
  RuleImplementationType as ApiRuleImplementationType,
  RuleFragmentFragment,
} from "src/graphql/anti-fraud/__generated__/graphql";
import { Rule, RuleBusinessType, RuleImplementationType } from "src/types/rule";

export const mapToRule = (fragment: RuleFragmentFragment): Rule => ({
  id: fragment.id,
  name: fragment.name,
  description: fragment.description,
  implementationType: mapToRuleImplementationType(fragment.implementationType),
  businessType: mapToRuleBusinessType(fragment.businessType),
  code: fragment.code,
});

const ruleBusinessTypeMapping: Record<ApiRuleBusinessType, RuleBusinessType> = {
  Comparison: "comparison",
  Velocity: "velocity",
  LinkedCase: "linkedCase",
  Blacklist: "blacklist",
  CaseProperties: "caseProperties",
};

export const mapToRuleBusinessType = (apiBusinessType: ApiRuleBusinessType): RuleBusinessType => {
  return ruleBusinessTypeMapping[apiBusinessType];
};

const ruleBusinessTypeReverseMapping = Object.entries(ruleBusinessTypeMapping).reduce(
  (reverseMap, [apiType, type]) => {
    reverseMap[type] = apiType as ApiRuleBusinessType;
    return reverseMap;
  },
  {} as Record<RuleBusinessType, ApiRuleBusinessType>
);

export const mapToApiRuleBusinessType = (businessType: RuleBusinessType): ApiRuleBusinessType => {
  return ruleBusinessTypeReverseMapping[businessType];
};

export const ruleImplementationTypeMapping: Record<
  ApiRuleImplementationType,
  RuleImplementationType
> = {
  predefined: "predefined",
  userdefined: "userDefined",
};

export const mapToRuleImplementationType = (
  apiImplementationType: ApiRuleImplementationType
): RuleImplementationType => {
  return ruleImplementationTypeMapping[apiImplementationType];
};
